import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ChatsService } from './ChatsApi';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { IChatListState } from '../../../../interfaces/chat/IChatListState';
import { PaginatedChats } from '../../../../interfaces/chat/paginatedStore.type';
import { AxiosError } from 'axios';

const initialState: IChatListState = {
    chatsAreLoading: false,
    chatIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchAllChats = createAsyncThunk<any, undefined | null>(
    'chats/tryToFetchAllChats',
    async () => {
        const result = await ChatsService.tryToFetchAllChats();
        return result?.data;
    }
);

export const tryToFetchChats = createAsyncThunk<PaginatedChats, IPaginationPayload>(
    'chats/tryToFetchChats',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await ChatsService.tryToFetchChats(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToCreateChatMessage = createAsyncThunk<any, any>(
    'chats/tryToCreateChatMessage',
    async (data, { rejectWithValue }) => {
        try {
            const result = await ChatsService.tryToCreateChatMessage(data);
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const tryToUploadChatFiles = createAsyncThunk<any, any>(
    'chats/tryToUploadChatFiles',
    async (data, { rejectWithValue }) => {
        try {
            const result = await ChatsService.tryToUploadChatFiles(data);
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const chatsSlice = createSlice({
    name: 'chats',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchAllChats
            .addCase(tryToFetchAllChats.pending, (state) => {
                state.chatsAreLoading = true;
            })
            .addCase(tryToFetchAllChats.rejected, (state) => {
                state.chatsAreLoading = false;
            })
            .addCase(tryToFetchAllChats.fulfilled, (state, action) => {
                state.chatsAreLoading = false;
                state.allChats = action.payload;
            })

            // tryToFetchChats
            .addCase(tryToFetchChats.pending, (state) => {
                state.chatsAreLoading = true;
            })
            .addCase(tryToFetchChats.rejected, (state) => {
                state.chatsAreLoading = false;
            })
            .addCase(tryToFetchChats.fulfilled, (state, action) => {
                state.chatsAreLoading = false;
                state.chats = action.payload;
            })

    },
});

export default chatsSlice.reducer;